import { render, staticRenderFns } from "./AccountTabSalaryHistory.vue?vue&type=template&id=5702bdac"
import script from "./AccountTabSalaryHistory.vue?vue&type=script&lang=js"
export * from "./AccountTabSalaryHistory.vue?vue&type=script&lang=js"
import style0 from "./AccountTabSalaryHistory.vue?vue&type=style&index=0&id=5702bdac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports